import tracking from '@g4/g4-analytics';
import _ from 'lodash';
import moment from '@g4/moment-utc';

export const trackErrorEvent = errors => {
  let eventLabels = errors?.map(e => {
    switch (e) {
      case 'DRIVER_MINIMUM_AGE_POLICY_NOT_MET': {
        return 'Skip Car Younger Than Minimum Age';
      }
      case 'RENTAL_DURATION_MAX_LIMIT_EXCEEDED': {
        return 'Skip Car Greater than 30 Days';
      }
      default:
        return 'Skip Car Timeout';
    }
  });

  _.forEach(eventLabels, function(eventLabel) {
    tracking.trackEvent('client_side_error', eventLabel);
  });
};

export const trackPaginationEvent = page => {
  tracking.trackEvent(
    'site_click_tracking',
    'Cars',
    'Page Number | ' + page,
    null
  );
};

export const trackNoCarsMessageEvent = route => {
  tracking.trackZeroSearchResults(route);
};

// Partial Rental Car - when we customized default rental dates
// Returns False if the dates are not customized
// Returns True if the dates are customised
export const isPartialRentalCar = (orderFlights, searchCriteria) => {
  const isOneWay = orderFlights?.length === 1;

  if (!isOneWay && orderFlights) {
    const arrivalDate = moment(
      orderFlights[0]?.flight.arrivalTime.split('T')[0]
    );
    const departingDate = moment(
      orderFlights[1]?.flight.departingTime.split('T')[0]
    );

    return (
      (arrivalDate.diff(moment(searchCriteria.startDay), 'days') ||
        departingDate.diff(moment(searchCriteria.endDay), 'days')) !== 0
    );
  }

  return true;
};

const getCarPromoItems = ({
  carData,
  promo,
  operatedBy,
  route,
  affinityString,
  destination,
}) => {
  const carSize = carData.vehicle.category;
  const carItemVariant = `${carSize}-${carData.vehicle.type}-${destination}`;
  const vendorOffers = carData.vendorOffer;

  const carPromoItems = vendorOffers.map((vendorOffer, index) => ({
    item_id: vendorOffer.id,
    item_name: vendorOffer.vendor.name,
    coupon: promo?.code,
    discount: promo?.headlineDescription ?? '',
    affiliation: 'WWW - Booking',
    index: index + 1,
    item_brand: (operatedBy && operatedBy.carrier) || 'G4',
    item_category: '3rd Party/Cars',
    item_category2: carSize,
    item_category3: 'D',
    item_category4: route,
    item_category5: affinityString,
    item_variant: carItemVariant,
    price: '',
    quantity: 1,
    item_promotion_name: promo?.headlineDescription,
    item_promotion_id: promo?.id,
  }));
  return carPromoItems;
};

export const getCarPromoData = (
  carIndex,
  carData,
  promo,
  operatedBy,
  route,
  affinityString,
  destination
) => {
  return {
    creative: promo?.code,
    name: promo?.headlineDescription,
    position: `slot ${carIndex + 1}-CarsPage`,
    id: promo?.id,
    items: getCarPromoItems({
      carData,
      promo,
      operatedBy,
      route,
      affinityString,
      destination,
    }),
  };
};

export const trackPromoClickEvent = (
  promo,
  carIndex,
  car,
  operatedBy,
  route,
  affinityString,
  destination
) => {
  tracking.trackPromoSelect(
    getCarPromoData(
      carIndex,
      car,
      promo,
      operatedBy,
      route,
      affinityString,
      destination
    )
  );
};

export const trackUpliftAmountClick = () => {
  tracking.trackEvent(
    'site_click_tracking',
    'Cars',
    'Uplift Pay Monthly Message'
  );
};

export const trackUpliftLogoClick = () => {
  tracking.trackEvent('site_click_tracking', 'Cars', 'Uplift Logo');
};
